export enum WindowSizes {
  sm = 786,
}
